<template>
    <div class="Disclaimer font-thin" :class="{'Disclaimer--active' : value}">
        <div class="Disclaimer__content">
            <div class="Disclaimer__checkbox">
                <Checkbox
                    :value="value"
                    class="ml-none"
                    aria-label="I have read the Purpose, Assumptions, Methodology & Disclaimer"
                    @input="$emit('input', $event)"
                />
                <span><span class="font-medium">Before you begin:</span> I have read <a href="./static/assumptions.pdf" target="_blank">Purpose, Assumptions, Methodology & Disclaimer</a></span>
            </div>
            <p v-if="showError && !value" id="form-error" class="Disclaimer__error">Please check the box to confirm you have read the Purpose, Assumptions, Methodology and Disclaimer before proceeding.</p>
        </div>
    </div>
</template>

<script>
    import Checkbox from '@/components/Checkbox.vue';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true
            },
            showError: {
                type: Boolean,
                required: true
            }
        },

        components: { Checkbox }
    }
</script>

<style scoped lang="scss">
    .Disclaimer {
        display: flex;
        justify-content: center;
        margin-right: auto;
        margin-left: auto;
        max-width: 400px;
        padding: 15px;
        background-color: #fff;
        color: #000;
        border-radius: 5px;
        border: 1px solid #BBB3B3;
        text-align: left;
    }

    .Disclaimer__content {
        text-align: left;
        font-size: 12px;

        @media screen and (min-width: 768px) {
            font-size: 16px;
        }
    }

    .Disclaimer__error {
        margin-top: 20px !important;
        color: #f72525;
        text-align: center;
        padding-left: 0 !important;
    }

    .Disclaimer__checkbox {
        position: relative;
        display: inline-block;
        padding-left: 60px;
    }

    .Disclaimer__checkbox .Checkbox {
        position: absolute;
        left: 9px;
        top: 9px;
    }

    .Disclaimer p {
        margin: 0;
        padding: 0 0 0 30px;
        background-repeat: no-repeat;
        background-position: 0 50%;
        background-size: auto 21px;
        font-size: 0.9em;
    }

    @media screen and (max-width: 585px) {
        .Disclaimer p {
            padding: 0;
            background-image: none !important;
            text-align: center;
        }
    }

    .Disclaimer a {
        text-decoration: underline;
    }

    .Disclaimer--active {
        background-color: #00928A;
        color: #fff;

        a {
            color: #fff;
        }
    }

</style>
